<template>
  <section class="section">
    <div class="container">
      <h1 class="admin-page">Platos de Comidas</h1>
      <div class="pull-right">
            <router-link to="/platoform" class="btn btn-primary btn-fill pull-right">NUEVO PLATO</router-link>      
      </div>
        <div class="row" v-if="platos.length === 0">
          <div class="text-center center-block placeholder">
            <h1>No tienes platos cargados</h1>
          </div>
        </div>
        <div class="row" v-if="platos.length > 0">
          <div class="col-xs-12">
           <ul class="nav nav-tabs" role="tablist">
            <li v-for="cat, idx in Object.keys(categorias)" :class="{active: categoriaActiva === cat}" :aria-controls="cat" role="tab" data-toggle="tab">
              <a @click.prevent="setCategoriaActiva(cat)" href="#">
                {{cat}}
              </a>
            </li>
            </ul>
            <div class="tab-content">
            <div role="tabpanel" class="tab-pane fade in active" id="entradas">
              <div class="table-header form smart-form">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                    <div class="form-group">
                      <div class="input-group search-box">
                        <input type="text" class="form-control" v-model="search" placeholder="Búsqueda rápida">
                        <span class="input-group-btn">
                        <button class="btn btn-default" type="button"><i class="fa fa-search"></i></button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-container">
                <table class="table table-hover table-stripped table-no-first-pad">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Descripcion</th>                      
                      <th class="text-right">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="plato in filteredItems">
                      <td>{{plato.nombre}}</td>
                      <td>{{plato.descripcion}}</td>
                      <td>
                        <ul class="table-actions smart-form">
                          <li>
                            <a href="" class="btn btn-xs btn-ghost" type="button">
                              <i class="fa fa-actions fa-eye"></i>
                            </a>
                          </li>
                          <li>
                            <a class="btn btn-xs btn-ghost js-editar" type="button" :data-id="plato._id">
                              <i class="fa fa-actions fa-pencil"></i>
                            </a>
                          </li>
                          <li>
                            <a href="" class="btn btn-xs btn-ghost" type="button">
                              <i class="fa fa-actions fa-times"></i>
                            </a>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          </div>
        </div>
    </div>
  </section>
</template>
<script>
  import $ from 'jquery'
  import 'datatables.net'
  import 'datatables.net-dt/css/jquery.dataTables.css'
  import mixinRestaurante from '../../mixins/RestauranteLogged'
  
  export default {
    mixins: [mixinRestaurante],
    data () {
      return {
        platos: [],
        categorias: {},
        categoriaActiva: '',
        search: '',
        tabla: undefined
      }
    },
    mounted () {
      const me = this
      me.$http.get('/api/platos').then(({body}) => {
        me.platos = body
        let cats = {}
        let firstCat
        me.platos.map(plato => {
          if (!firstCat) {
            firstCat = plato.categoria.nombre
          }
          let dishes = cats[plato.categoria.nombre]
          if (!dishes) {
            dishes = []
          }
          dishes.push(plato)
          cats[plato.categoria.nombre] = dishes
        })
        me.categorias = cats
        me.categoriaActiva = firstCat
      }, (err) => {
        console.log(err)
      }).then(() => {
        $('body').on('click', '.js-editar', (e) => {
          e.preventDefault()
          const id = $(e.currentTarget).data('id')
          me.$router.push('/platoform/edit/' + id)
        })
      })
    },
    computed: {
      filteredItems () {
        if (this.categorias[this.categoriaActiva]) {
          return this.categorias[this.categoriaActiva].filter(item => {
            return item.nombre.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          })
        } else {
          return []
        }
      }
    },
    methods: {
      setCategoriaActiva (cat) {
        const me = this
        me.categoriaActiva = cat
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Platos.vue?238a0066